import { ColorService } from "./color.service";
import { LanguageService } from "./language.service";
import { Injectable } from "@angular/core";

@Injectable()
export class WatchService {
  private lang: LanguageService;

  // Images used in watch
  private checkMarkActivated = document.createElement("img");
  private checkMarkDeactivated = document.createElement("img");
  private colourField = document.createElement("div");
  private imgSize = 25;

  // Used if language gets changed
  private latestTurtle;

  constructor(lang: LanguageService) {
    this.lang = lang;
    this.lang.space.subscribe(val =>
      function() {
        if (val != undefined) {
          this.updateDebugWatch(this.latestTurtle);
        }
      }.bind(this)
    );

    this.checkMarkActivated.src = "app/img/debugIcons/field_activated.png";
    this.checkMarkDeactivated.src = "app/img/debugIcons/field_deactivated.png";

    this.colourField.style.height = (this.imgSize - 4).toString() + "px";
    this.colourField.style.width = (this.imgSize - 4).toString() + "px";
    this.colourField.style.borderRadius = "5px";
    this.colourField.style.border = "2px solid #1F1F1F";
  }

  // Sets the values of the turtle state in the debug watch
  public updateDebugWatch(turtle): void {
    this.latestTurtle = turtle;

    // Add new information
    this.updateWatchEntry("watchPenDown", turtle.getPenDown());
    this.updateWatchEntry("watchErasing", turtle.getErasing());
    this.updateWatchEntry("watchVisible", turtle.getVisibility());
    this.updateWatchEntry("watchColor", turtle.getPenColor());
    this.updateWatchEntry("watchWidth", turtle.getPenWidth().toString());
    this.updateWatchEntry(
      "watchDirection",
      (turtle.getDirection() % 360).toString() + "°"
    );
  }

  // Adds a single element to the debug watch
  private updateWatchEntry(
    id: string,
    entryValue: ColorService | boolean | string
  ): void {
    // Create nodes (name and value)
    const entryNameNode = document.createTextNode(this.lang.translateKey(id));
    const entryValueNode = this.createValueNode(entryValue);

    // Assign values
    const entryNameCell = document.getElementById(id + "Name");
    const entryValueCell = document.getElementById(id + "Value");
    WatchService.removeChildren(entryNameCell);
    WatchService.removeChildren(entryValueCell);
    entryNameCell.appendChild(entryNameNode);
    entryValueCell.appendChild(entryValueNode);
  }

  // Dynamically creates the value presented for a specific attribute
  private createValueNode(entryValue: ColorService | boolean | string): Node {
    let entryValueNode: Node;

    switch (typeof entryValue) {
      case "boolean":
        let checkMark = document.createElement("img");
        checkMark.style.height = this.imgSize.toString() + "px";
        checkMark.style.width = this.imgSize.toString() + "px";
        if (entryValue) {
          checkMark.src = this.checkMarkActivated.src;
        } else {
          checkMark.src = this.checkMarkDeactivated.src;
        }
        entryValueNode = checkMark;
        break;

      case "string":
        entryValueNode = document.createTextNode(<string>entryValue);
        break;

      default:
        this.colourField.style.backgroundColor = (<ColorService>(
          entryValue
        )).getColorString();
        entryValueNode = this.colourField;
        break;
    }

    return entryValueNode;
  }

  private static removeChildren(element: HTMLElement): void {
    while (element.hasChildNodes()) {
      element.removeChild(element.firstChild);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/watch.service.ts